import { useEffect, useState } from 'react';
import Table14 from '../tables/Table14'

const Template14 = ({ data }) => {
    const [info, setInfo] = useState();
    useEffect(() => {
        setInfo(data.rows.find(row => row.name === 'TOTAL'))
    }, [data]);

    return (
        <>
            {info?.count > 0 &&
                <div className='row chart-container'>
                    <div className='chart-header col-md-3'>
                        <h6 className="text-center">{data.title}</h6>
                    </div>
                    <div className='chart-content col-md-9 px-0'>
                        <Table14 apiData={data} />
                    </div>
                </div>
            }
        </>
    )
}

export default Template14 
